import { functions, httpsCallable } from '/Users/michaeltucker/Documents/coding-projects/client/src/firebase.js';
import { clearStoredReferralCode, getStoredReferralCode } from './referralStorage';

export async function attachStoredReferralAfterSignup() {
  const referralCode = getStoredReferralCode();
  if (!referralCode) {
    return { attached: false };
  }

  try {
    const initializeReferralForNewUser = httpsCallable(functions, 'initializeReferralForNewUser');
    const result = await initializeReferralForNewUser({ referralCode });
    clearStoredReferralCode();
    return result.data || { attached: false };
  } catch (error) {
    console.error('Failed to attach referral code during signup:', error);
    return { attached: false, error };
  }
}
